import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-comment-popup',
  templateUrl: './comment-popup.component.html',
  styleUrls: ['./comment-popup.component.scss']
})
export class CommentPopupComponent implements OnInit {

  maxCharacters: number = 500;

  form: UntypedFormGroup = new UntypedFormGroup({
    kommentar: new UntypedFormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<CommentPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }

  save() {
    this.dialogRef.close(this.form.value.kommentar);
  }

  close() {
    this.dialogRef.close();
  }

}
